import { Button, DatePicker, Space, Table } from "antd";
import WorktimeTable, { SignatureImage } from "../../fragments/worktime-table";
import { useCallback, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useGetEmployeeQuery, useGetWorkTimes2Query } from "../../../../api/plamo-api";
import dayjs from "dayjs";

const calcDuration = wt => {
  const diff = (dayjs(wt.endTimeEmployee).valueOf() - dayjs(wt.startTimeEmployee).valueOf()) / 1000 / 60;
  return ("00" + Math.floor(diff / 60)).substr(-2) + ":" + ("00" + Math.floor(diff % 60)).substr(-2);
}

const calcWorkTimesSum = (wts: any[]): string => {
  const sum = wts.map(wt => (dayjs(wt.endTime).valueOf() - dayjs(wt.startTime).valueOf()) / 1000 / 60).reduce((p: number, c: number) => p + c, 0);
  return (sum / 60).toFixed(2).replace('.', ',');
}


const ReportEmployeeName = ({ record }) => {
  const { data: employee } = useGetEmployeeQuery({ id: record.employeeId }, { skip: !record.employeeId }) as any;
  return <>
    {employee && `${employee.firstName} ${employee.lastName}`}
  </>;
}


function CustomerTimesheet({ customerId, customer }) {
  const userToken = useSelector(state => (state as any).user?.userToken);
  const [selectedMonth, setSelectedMonth] = useState<any>(null);
  const begin = useMemo(() => dayjs(selectedMonth).date(1).hour(0).minute(0).second(0).millisecond(0),  [selectedMonth])
  const end = useMemo(() => dayjs(begin).add(1, 'month'),  [begin])
  const { data: workTimes } = useGetWorkTimes2Query({ f: JSON.stringify({ 
    "customerId": { c: "EQ", v: customerId },
    "changeRequestForId": { c: "EQ", v: null },
    "startTime": { 
      c: "BTW", 
      v: dayjs(begin).utc().format('YYYY-MM-DDTHH:mm:ss') + '.000', 
      v2: dayjs(end).utc().format('YYYY-MM-DDTHH:mm:ss') + '.000', 
      t: 'DATE' 
    }
  }), st: JSON.stringify({ "id": "asc" }) }, { skip: !begin || !end }) as any;
  const pdfReportContentRef = useRef<any>();
  
  const generatePdf = useCallback(async () => {

    /*
    const pdfReportContent = pdfReportContentRef.current?.innerHTML;

    const html = `
      <style type="text/css">
        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid black;
          text-align: center;
        }        
      </style>

      ${pdfReportContent}
    `

    const response = await fetch("/api/plamo/contract-template/pdf", { method: 'POST', body: html, headers: { 'Content-Type': 'text/html', 'Authorization': `Bearer ${userToken}` } });
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a") as any;
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "Stundenzettel.pdf";
    a.click();
    window.URL.revokeObjectURL(url);
    */

    const response = await fetch(`/api/plamo/report/customer-timesheet?customerId=${customerId}&budget=supportAmount,absenceCare,conversion,otherBudgetAmount&begin=${dayjs(begin).utc().format('YYYY-MM-DDTHH:mm:ss') + '.000'}&end=${dayjs(end).utc().format('YYYY-MM-DDTHH:mm:ss') + '.000'}`, { method: 'GET', headers: { 'Content-Type': 'text/html', 'Authorization': `Bearer ${userToken}` } });
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a") as any;
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = `Leistungsnachweis ${customer.firstName} ${customer.lastName}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
  }, [userToken, customer, customerId, begin, end])

  return (<>
    <DatePicker picker="month" placeholder="Monat auswählen" format={'MM/YYYY'} value={selectedMonth} onChange={setSelectedMonth} />

    { selectedMonth && 
    <>
      <div style={{ textAlign: 'right' }}>
        <Space size="small">
          <Button type="primary" onClick={() => generatePdf()}>
            PDF erstellen
          </Button>
        </Space>
      </div>

      <h2>Zusammenfassung</h2>

      <Table
      pagination={false} 
      columns={[
        {
          title: "Beschreibung",
          dataIndex: "ident",
        },
        {
          title: "Summe",
          dataIndex: "sum",
        },
      ]}
      dataSource={[
        {
          ident: "Stunden geleistet",
          sum: workTimes?.items ? calcWorkTimesSum(workTimes.items) : 0
        }
      ]}
      />

      <h2>Arbeitszeiten</h2>

      <WorktimeTable 
        preselectedCustomerId={customerId}
        begin={begin} 
        end={end}
      />

      <div ref={pdfReportContentRef} style={{ display: "none" }}>
        <h1>Stundenzettel</h1>
        <table>
          <tr>
            <td>Kunde:</td><td>{customer?.firstName} {customer?.lastName}</td>
          </tr>
          <tr>
            <td>Zeitraum:</td><td>{dayjs(begin).format('DD.MM.YYYY')} - {dayjs(end).subtract(1, 'day').format('DD.MM.YYYY')}</td>
          </tr>
        </table>

        <h2>Arbeitszeiten</h2>
        <table className="workTimes">
          <tr><th>Datum</th><th>Anfang</th><th>Ende</th><th>Mitarbeiter</th><th>Stunden</th><th>Unterschrift</th></tr>
          { workTimes?.items?.map((wt, idx) => 
            <tr><td>{dayjs(wt.startTime).format('DD.MM.YYYY')}</td><td>{dayjs(wt.startTime).format('HH:mm')}</td><td>{dayjs(wt.endTime).format('HH:mm')}</td><td><ReportEmployeeName record={wt} /></td><td>{calcDuration(wt)}</td><td><SignatureImage record={wt} /></td></tr>
          ) }
          <tr><td colSpan={3} style={{ border: "none" }}></td><th style={{ border: "none" }}>Gesamt</th><th>{workTimes?.items ? calcWorkTimesSum(workTimes.items) : ''}</th><th></th></tr>
        </table>
    </div>
    </>}
    </>)
}

export default CustomerTimesheet;